var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14190_96)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14190_96",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.33332C26.3249 9.33332 24.7048 9.55338 23.1653 9.96488L21.9602 5.4565C23.8892 4.94087 25.9144 4.66666 28 4.66666C30.0856 4.66666 32.1107 4.94087 34.0397 5.4565L32.8346 9.96487C31.2952 9.55338 29.6751 9.33332 28 9.33332Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 11.83C15.8333 13.4695 13.4695 15.8333 11.83 18.6669L7.79072 16.3298C9.83895 12.7897 12.7897 9.83898 16.3297 7.79075L18.6668 11.83Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1699 18.6669C42.5305 15.8333 40.1666 13.4695 37.3331 11.83L39.6702 7.79075C43.2102 9.83898 46.161 12.7897 48.2092 16.3298L44.1699 18.6669Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6666 28C46.6666 26.3249 46.4466 24.7048 46.0351 23.1654L50.5435 21.9603C51.0591 23.8892 51.3333 25.9144 51.3333 28C51.3333 30.0856 51.0591 32.1107 50.5435 34.0397L46.0351 32.8346C46.4466 31.2952 46.6666 29.6751 46.6666 28Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96484 23.1654C9.55335 24.7048 9.33329 26.3249 9.33329 28C9.33329 29.6751 9.55335 31.2952 9.96485 32.8346L5.45647 34.0397C4.94084 32.1107 4.66663 30.0856 4.66663 28C4.66663 25.9144 4.94084 23.8892 5.45647 21.9603L9.96484 23.1654Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 37.3331C13.4695 40.1667 15.8333 42.5305 18.6668 44.17L16.3297 48.2092C12.7897 46.161 9.83895 43.2103 7.79072 39.6702L11.83 37.3331Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3331 44.17C40.1666 42.5305 42.5305 40.1667 44.1699 37.3331L48.2092 39.6702C46.161 43.2103 43.2102 46.161 39.6702 48.2092L37.3331 44.17Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1653 46.0351C24.7048 46.4466 26.3249 46.6667 28 46.6667C29.6751 46.6667 31.2952 46.4466 32.8346 46.0351L34.0397 50.5435C32.1107 51.0591 30.0856 51.3333 28 51.3333C25.9144 51.3333 23.8892 51.0591 21.9602 50.5435L23.1653 46.0351Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14190_96)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14190_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderDash);
export default __webpack_public_path__ + "static/media/loaderDash.3eacea2b1066cadbf59dc9b01d827f7d.svg";
export { ForwardRef as ReactComponent };